import React, { FC } from "react"
import Dropdown from "react-bootstrap/Dropdown"
import { faPowerOff, faEdit } from "@fortawesome/pro-duotone-svg-icons"
import classes from "./DropdownMenu.module.scss"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { AuthConsumer, authContext } from "../../../context/auth/authContext"
import { Link } from "gatsby"
import { faCompress, faExpand } from "@fortawesome/pro-light-svg-icons"
import Can from "../../../context/can"

//TODO: drop in dynamic avatar images once blob is ready
const DropdownMenu: FC = () => {
  const context = React.useContext(authContext)
  const [fullscreen, setFullscreen] = React.useState(false)
  const [ios, setIos] = React.useState(false)

  const launchIntoFullscreen = element => {
    if (element.requestFullscreen) {
      element.requestFullscreen()
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen()
    } else if (element.webkitRequestFullscreen) {
      element.webkitRequestFullscreen()
    } else if (element.msRequestFullscreen) {
      element.msRequestFullscreen()
    }
  }

  const exitFullscreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen()
      // @ts-ignore
    } else if (document.mozCancelFullScreen) {
      // @ts-ignore
      document.mozCancelFullScreen()
      // @ts-ignore
    } else if (document.webkitExitFullscreen) {
      // @ts-ignore
      document.webkitExitFullscreen()
    }
  }

  const checkFullScreen = () => {
    if (document && document.fullscreenElement !== null) {
      setFullscreen(true)
    } else {
      setFullscreen(false)
    }
  }

  React.useEffect(() => {
    if (
      navigator &&
      [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod",
      ].includes(navigator.platform)
    ) {
      setIos(true)
    }
  })

  React.useEffect(() => {
    document.addEventListener("fullscreenchange", checkFullScreen)

    return () => {
      document.removeEventListener("fullscreenchange", checkFullScreen)
    }
  }, [])

  return (
    <AuthConsumer>
      {context => (
        <>
          <Dropdown>
            <Dropdown.Toggle variant="outline-link" id="dropdown-basic">
              <img
                src={
                  context.user.avatar && context.user.avatar !== ""
                    ? context.user.avatar
                    : "https://firebasestorage.googleapis.com/v0/b/hallen-frontend.appspot.com/o/default.jpg?alt=media&token=6b00a40e-c9d8-4af1-8681-2959e6fc38bb"
                }
                className={classes.avatar}
              />
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Can
                perform="userUserSelfProfileUpdate:create"
                yes={() => (
                  <Dropdown.Item
                    as={Link}
                    to={`/editprofile?id=${context.user.userId}`}
                  >
                    {" "}
                    <FontAwesomeIcon icon={faEdit} /> Edit Profile
                  </Dropdown.Item>
                )}
                no={() => <></>}
              />
              {!ios && (
                <Dropdown.Item
                  onClick={
                    fullscreen
                      ? exitFullscreen
                      : () => launchIntoFullscreen(document.documentElement)
                  }
                >
                  <FontAwesomeIcon icon={fullscreen ? faCompress : faExpand} />
                  {fullscreen ? " Exit Fullscreen" : " Fullscreen"}
                </Dropdown.Item>
              )}
              {/*@ts-ignore*/}
              <Dropdown.Item
                onClick={() => {
                  sessionStorage.setItem("targetUrl", "logout");

                  if(context.isAdUser){
                    context.adLogout();
                  } else {
                    context.logout();
                  }
                }}
              >
                <FontAwesomeIcon icon={faPowerOff} /> Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </>
      )}
    </AuthConsumer>
  )
}

export default DropdownMenu
